import script from "./report-2.vue?vue&type=script&setup=true&lang=js"
export * from "./report-2.vue?vue&type=script&setup=true&lang=js"

import "./report-2.vue?vue&type=style&index=0&id=f76fe85c&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f76fe85c"]])

export default __exports__